/* eslint-disable class-methods-use-this,react/jsx-no-bind */
import Router from 'next/router';
import { Component } from 'react';
import Modal from 'react-modal';
import Slider from 'react-slick';
import { toast } from 'react-toastify';
import LoadingProgress from '@/components/common/LoadingProgress';
import { LeadCategory } from '@/_models/TourLead';
import { TourTypeURL } from '@/_models/Tour';
import Iframe from '../../../units/Iframe';
import { CustomCookieConsent } from '../../common/CookieConsent';
import * as all from '../../util/all';
import { fetchData } from '../../util/all';
import { downloadAllImages, downloadImage } from '../helper';
import FloorPlan from '../overview/floorPlan/FloorPlan';
import Map from '../overview/map/Map';
import Summary from '../overview/summary/Summary';
import { DownloadAll } from '../style';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ReactTooltip = require('react-tooltip').default;

export default class SlickPublicAsset extends Component<any, any> {
  root: any;

  tour: any;

  map: any;

  overview: any;

  amenities: any;

  floorPlans: any;

  contact: any;

  matterTour: any;

  tourScheduler: any;

  constructor(props: any) {
    super(props);
    this.toggleVideo = this.toggleVideo.bind(this);
    this.state = {
      tour: null,
      play: false,
      videoOpen: false,
      galleryOpen: false,
      selectedPlan: null,
      schedulerDates: [],
      images: [],
      newLead: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        message: null,
      },
      activeTab: 0,
      selectedDate: null,
      selectedAgent: 0,
      downloading: false,
    };
    this.scrollTo = this.scrollTo.bind(this);
  }

  componentDidMount() {
    const { tour } = this.props;
    this.setState({
      tour,
      selectedPlan: tour.floorPlans.length > 0 ? tour.floorPlans[0].url : null,
    });
    this.setSchedulerDates(new Date(), true);
    const { menuItemClickedBookingPage } = this.props;
    if (menuItemClickedBookingPage) {
      if (menuItemClickedBookingPage === 'gallery') {
        this.toggleGallery();
      } else {
        setTimeout(this.scrollTo.bind(this, menuItemClickedBookingPage), 1000);
      }
    }
  }

  setSchedulerDates(startDate: Date, init: boolean) {
    const td = startDate;
    const tm = new Date(td);
    tm.setDate(tm.getDate() + 1);
    const nd = new Date(td);
    nd.setDate(nd.getDate() + 2);
    const schedulerDates = [td, tm, nd];
    this.setState({ schedulerDates });
    if (init) this.setState({ selectedDate: td });
  }

  editLead(event: any) {
    const { name } = event.target;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    const { newLead } = this.state;
    newLead[name] = value;
    this.setState({ newLead });
  }

  async sendLead() {
    const params = Object.assign(this.state.newLead, {
      tour: this.state.tour.title,
      userId: this.state.tour.userId,
      link: window.location.href,
      clientId: this.state.tour?.client?.id,
    });
    const { tourEmail, client } = this.state.tour;
    try {
      await fetchData('public/sendEmail', 'POST', {
        to: (tourEmail && tourEmail.assertGetInTouch) || (client && client.email),
        params,
      });
      toast.success('E-Mail sent');
      this.setState({
        newLead: {
          name: null,
          email: null,
          phone: null,
          message: null,
        },
      });
      await fetchData('public/setTourLead', 'POST', {
        name: params.name,
        email: params.email,
        phone: params.phone,
        category: LeadCategory.AssertTouchForm,
        tourId: this.state.tour.id,
      });
    } catch (err) {
      console.error(err.message);
    }
  }

  switchPlan(url: string, index: number) {
    const { tour } = this.state;
    tour.floorPlans.map((plan: any) => {
      plan.selected = false;
      return plan;
    });
    tour.floorPlans[index].selected = true;
    this.setState({ tour, selectedPlan: url });
  }

  async downloadCurrentImage(url: string) {
    this.setState({ loading: true });
    await downloadImage(url, this.state.tour);
    this.setState({ loading: false });
  }

  toggleGallery() {
    const tour = this.state.tour ? this.state.tour : this.props.tour;

    if (this.state.images.length === 0) {
      all
        .fetchData('public/getAllTourImages', 'POST', {
          id: tour.id,
        })
        .then((data) => {
          if (!data.images) {
            toast.error("Couldn't load images");
          } else {
            const images = data.images.map((img: any) => `${this.props.reactAws}/tours/${tour.id}/images/${img.url}`);
            this.setState({ images });
          }
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
    this.setState({
      galleryOpen: !this.state.galleryOpen,
      videoOpen: false,
    });
  }

  scrollTo(to: any) {
    this[to].scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

  toggleVideo() {
    const { videoOpen } = this.state;
    this.setState({
      videoOpen: !videoOpen,
      galleryOpen: false,
    });
  }

  moveDates(older: boolean) {
    const { schedulerDates } = this.state;
    const currentStart = schedulerDates[0];
    const newStart = new Date(currentStart);
    const diff = older ? -1 : 1;
    newStart.setDate(newStart.getDate() + diff);
    this.setSchedulerDates(newStart, false);
  }

  bookAppointment(incomingSelectedDate: any, appointmentType: any) {
    const selectedDate = encodeURIComponent(incomingSelectedDate);
    const { matterId } = this.props;
    Router.push({
      pathname: `/asset/${matterId}/book`,
      query: { date: selectedDate, appointmentType },
    });
  }

  async downloadAll() {
    const { images } = this.state;
    this.setState({
      downloading: true,
    });
    await downloadAllImages(images, this.state.tour);
    this.setState({
      downloading: false,
    });
  }

  public render() {
    const { tour, appointmentType, schedulerDates, selectedDate, downloading } = this.state;
    let summaryOn = false;
    let floorPlansOn = false;
    let iframeSrcPrefixByTourType;
    const galleryImages: any[] = [];
    const fbAppId = tour?.client?.fbAppId || tour?.user?.fbAppId;

    const { whitelabel } = this.props;

    if (tour) {
      summaryOn = (tour.summary && tour.summary.length) > 0;
      floorPlansOn = tour.floorPlansEnabled && !!tour.floorPlans.length;
      for (let i = 0; i < 6; i += 1) {
        const obj = tour.images[i] ? tour.images[i] : null;
        if (obj) galleryImages.push(obj);
      }
      iframeSrcPrefixByTourType = TourTypeURL[tour.mode];
    }

    if (this.state.loading || !tour) {
      return <LoadingProgress />;
    }

    return (
      <div
        id="public-asset-root"
        ref={(el) => {
          this.root = el;
        }}
        className={tour.client && tour.client.rtl ? 'rtl slick' : 'ltr slick'}
      >
        <Modal className="popup" isOpen={this.state.videoOpen} onRequestClose={this.toggleVideo} appElement={this.root}>
          <a onClick={this.toggleVideo}>
            <i className="fa fa-times" />
          </a>
          {tour.videoUrl && <Iframe logoSrc={whitelabel?.logo} src={all.getVideoLink(tour.videoUrl)} allowFullscreen />}
        </Modal>

        <Modal className="popup" isOpen={this.state.galleryOpen} onRequestClose={this.toggleGallery.bind(this)} appElement={this.root}>
          <a onClick={this.toggleGallery.bind(this)}>
            <i className="fa fa-times" />
          </a>
          {tour.client?.logo && (
            <img
              className={tour.client.widthLogo ? 'logo width' : 'logo'}
              src={`${this.props.reactAws}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)}`}
              alt=""
            />
          )}
          {tour.client?.watermark && (
            <img className="watermark" alt="" src={`${this.props.reactAws}/clients/${tour.client.id}/watermark.png${all.getVersion(tour.client.updatedAt)}`} />
          )}
          <Slider className="gallery-slider" infinite={false} arrows autoplay={false} dots={false} fade={false}>
            {this.state.images.map((image: string, i: number) => (
              <div key={i}>
                <div
                  className="bg"
                  style={{
                    backgroundImage: `url(${image})`,
                  }}
                >
                  <DownloadAll onClick={this.downloadAll.bind(this)}>
                    {downloading ? <i className="fas fa-spinner fa-spin" /> : <i className="fas fa-angle-double-down" />}
                  </DownloadAll>
                  <i onClick={this.downloadCurrentImage.bind(this, image)} className="download fas fa-cloud-download-alt" />
                </div>
              </div>
            ))}
          </Slider>
        </Modal>

        {/* TODO: HEADER: scrollTop === 0 ? "transparent bg" : "white bg" */}
        <header className="slick-header w-100">
          <div className="d-flex justify-content-between align-items-center pr-5 pl-5 h-100">
            <div className="d-flex header-logo align-items-center">
              {tour.client?.logo && !tour.unbranded && (
                <img className="logo" alt="" src={`${this.props.reactAws}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)}`} />
              )}
            </div>
            <div />
            <div className="navi">
              <div className="d-flex align-items-center h-100">
                <a onClick={this.scrollTo.bind(this, 'overview')}>{tour.translation?.overview}</a>
                <a onClick={this.toggleGallery.bind(this)}>{tour.translation?.photos}</a>
                {tour.amenities && <a onClick={this.scrollTo.bind(this, 'amenities')}>{tour.translation?.amenities}</a>}
                {tour.videoUrl && <a onClick={this.toggleVideo}>{tour.translation?.video}</a>}
                <a
                  onClick={() => {
                    this.scrollTo('floorPlans');
                    this.setState({ activeTab: 0 });
                  }}
                >
                  {tour.translation?.threeDTour}
                </a>
                {floorPlansOn && (
                  <a
                    onClick={() => {
                      this.scrollTo('floorPlans');
                      this.setState({ activeTab: 1 });
                    }}
                  >
                    {tour.translation?.floorPlans}
                  </a>
                )}
                {!tour.unbranded && <a onClick={this.scrollTo.bind(this, 'contact')}>{tour.translation?.contact}</a>}
                {tour.address && <a onClick={this.scrollTo.bind(this, 'map')}>{tour.translation?.map}</a>}

                {tour.appointmentsOn && (
                  <button onClick={this.scrollTo.bind(this, 'tourScheduler')} className="schedule-btn">
                    {tour.translation?.scheduleTour}
                  </button>
                )}
              </div>
            </div>
          </div>
        </header>

        <div className="content">
          <div className="intro">
            <div className="slider-overlay" />
            <Slider className="main-slider" infinite arrows={false} autoplay dots={false} fade autoplaySpeed={8000} speed={3000} cssEase="cubic-bezier(0.7, 0, 0.3, 1)">
              {tour.images.slice(0, 7).map((image: any, i: number) => (
                <div key={i}>
                  <div
                    className="bg"
                    style={{
                      backgroundImage: `url(${this.props.reactAws}/tours/${tour.id}/images/${image.url})`,
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
          <div className="slider-content w-100">
            {tour.address && (
              <div className="address d-flex align-items-center mb-3">
                <i className="fas fa-map-marker-alt" />
                <p className="m-0 ml-3">{tour.address}</p>
              </div>
            )}
            <div className="d-flex justify-content-between">
              <div className="w-50">
                <p className="tour-title mb-5">{tour.title}</p>
                {tour.price && (
                  <div>
                    <p className="price-lbl mb-3">Price</p>
                    <p className="price mb-2">{tour.price}</p>
                    <p className="price-old">{tour.oldPrice}</p>
                  </div>
                )}
              </div>
              <div />
              <div className="d-flex align-items-end flex-column">
                <div
                  className="option d-flex align-items-center justify-content-center"
                  data-tip={tour.translation?.threeDTour}
                  onClick={() => {
                    this.scrollTo('floorPlans');
                    this.setState({ activeTab: 0 });
                  }}
                >
                  <i className="fas fa-hand-pointer" />
                </div>
                <ReactTooltip place="left" effect="solid" type="light" />
                <div className="option d-flex align-items-center justify-content-center" data-tip={tour.translation?.gallery} onClick={this.toggleGallery.bind(this)}>
                  <i className="fas fa-images" />
                </div>
                <ReactTooltip place="left" effect="solid" type="light" />
              </div>
            </div>
          </div>
          <div
            className="info-wrapper d-flex justify-content-center w-100"
            id="info"
            ref={(el: any) => {
              this.overview = el;
            }}
          >
            {(tour.beds || tour.showers || tour.size || tour.cars || tour.accomodation || tour.price) && (
              <div className="info-box d-flex align-items-center pr-4 pl-4">
                {tour.beds && (
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="iconWrapper d-flex align-items-center justify-content-center">
                        <i className="fas fa-bed" />
                      </div>
                      <div className="col p-0">
                        <div className="d-flex justify-content-start">
                          <div className="col">
                            <p className="amenity">{tour.translation?.rooms}</p>
                            <p className="number">{tour.beds}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {tour.showers && (
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="iconWrapper d-flex align-items-center justify-content-center">
                        <i className="fas fa-shower" />
                      </div>
                      <div className="col p-0">
                        <div className="d-flex justify-content-start">
                          <div className="col">
                            <p className="amenity">{tour.translation?.bathrooms}</p>
                            <p className="number">{tour.showers}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {tour.cars && (
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="iconWrapper d-flex align-items-center justify-content-center">
                        <i className="fas fa-car" />
                      </div>
                      <div className="col p-0">
                        <div className="d-flex justify-content-start">
                          <div className="col">
                            <p className="amenity">{tour.translation?.parkingSpots}</p>
                            <p className="number">{tour.cars}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {tour.accomodation && (
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="iconWrapper d-flex align-items-center justify-content-center">
                        <i className="fas fa-home" />
                      </div>
                      <div className="col p-0">
                        <div className="d-flex justify-content-start">
                          <div className="col">
                            <p className="amenity">{tour.translation?.accommodation}</p>
                            <p className="number">{tour.accomodation}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {tour.size && (
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="iconWrapper d-flex align-items-center justify-content-center">
                        <i className="fas fa-ruler-combined" />
                      </div>
                      <div className="col p-0">
                        <div className="d-flex justify-content-start">
                          <div className="col">
                            <p className="amenity">{tour.translation?.size}</p>
                            <p className="number">
                              {tour.size} {tour.unitSystem === 'metric' ? 'm2' : 'ft'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {tour.price && (
                  <div className="flex-grow-1">
                    <div className="d-flex">
                      <div className="iconWrapper d-flex align-items-center justify-content-center">
                        <i className="fas fa-money-bill-wave" />
                      </div>
                      <div className="col p-0">
                        <div className="d-flex justify-content-start">
                          <div className="col">
                            <p className="amenity">{tour.translation?.price}</p>
                            <p className="number">{tour.price}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="details">
            {summaryOn && (
              <div className="d-flex justify-content-center">
                <div className="w-50 m-0 summary">
                  <Summary tour={tour} />
                </div>
              </div>
            )}

            <div id="gallery" className="d-flex justify-content-center flex-column align-items-center">
              <div className="row w-75 justify-content-center">
                {galleryImages.map((image: any, i: number) => (
                  <div key={i} className={i > 2 ? `align-start gcol gcol-${i}` : `gcol gcol-${i}`}>
                    <div
                      className="img"
                      onClick={this.toggleGallery.bind(this)}
                      style={
                        image.url
                          ? {
                              backgroundImage: `url(${this.props.reactAws}/tours/${tour.id}/images/${image.url})`,
                            }
                          : {}
                      }
                    />
                  </div>
                ))}
              </div>

              <a onClick={this.toggleGallery.bind(this)}>
                <div className="secondary-btn mt-5 mb-5">{tour.translation?.gallery}</div>
              </a>
            </div>

            {tour.appointmentsOn && (
              <div
                id="tourScheduler"
                className="slick-section grey-section"
                ref={(el: any) => {
                  this.tourScheduler = el;
                }}
              >
                <div className="d-flex justify-content-center">
                  <div className="w-50">
                    <h1 className="title">{tour.translation?.tourHouse}</h1>
                    <div className="d-flex">
                      <div className="col-8">
                        <div className="d-flex">
                          <div className="d-flex flex-column justify-content-center">
                            <div className="chevron-wrapper" onClick={this.moveDates.bind(this, true)}>
                              <i className="download fas fa-chevron-left" />
                            </div>
                          </div>
                          {schedulerDates &&
                            selectedDate &&
                            schedulerDates.map((date: Date, i: number) => (
                              <div key={i} className="col">
                                <div className={selectedDate === date ? 'selected' : ''}>
                                  <div
                                    className="date d-flex flex-column justify-content-center"
                                    onClick={() => {
                                      this.setState({ selectedDate: date });
                                    }}
                                  >
                                    <h6>{date.toLocaleString('en-US', { weekday: 'long' })}</h6>
                                    <h6 className="day mt-2 mb-2">{date.getDate().toString()}</h6>
                                    <h6>{date.toLocaleString('default', { month: 'short' })}</h6>
                                  </div>
                                </div>
                              </div>
                            ))}
                          <div className="d-flex flex-column justify-content-center">
                            <div className="chevron-wrapper" onClick={this.moveDates.bind(this, false)}>
                              <i className="download fas fa-chevron-right" />
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <p className="info">it's free, with no obligation - cancel anytime</p>
                        </div>
                      </div>
                      <div className="col-4 buttons">
                        <div
                          className={appointmentType === 'person' ? 'btn selected d-flex' : 'btn d-flex'}
                          onClick={() => {
                            this.setState({ appointmentType: 'person' });
                          }}
                        >
                          <i className="download fas fa-home mr-2" />
                          <p>Tour in Person</p>
                        </div>
                        {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
                        <div
                          role="button"
                          className={appointmentType === 'video' ? 'btn selected d-flex' : 'btn d-flex'}
                          onClick={() => {
                            this.setState({ appointmentType: 'video' });
                          }}
                        >
                          <i className="download fas fa-video mr-2" />
                          <p>Tour via Video Chat</p>
                        </div>
                        <a className="btn secondary d-flex" onClick={this.bookAppointment.bind(this, selectedDate, appointmentType)}>
                          Schedule Tour
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {tour.videoUrl && (
              <div className="slick-section">
                <div className="d-flex justify-content-center">
                  <div className="w-50">
                    <h1 className="title">{tour.translation?.video}</h1>
                    {tour.videoUrl && (
                      <Iframe logoSrc={whitelabel?.logo} className="video" src={all.getVideoLink(tour.videoUrl, { autoplay: 0 })} allowFullscreen />
                    )}
                  </div>
                </div>
              </div>
            )}

            {tour.amenities && (
              <div className="slick-section">
                <div className="d-flex justify-content-center">
                  <div className="w-50">
                    <h1 className="title">{tour.translation?.amenities}</h1>
                    <div
                      className="amenity-img"
                      style={{
                        backgroundImage: `url(${this.props.reactAws}/tours/${tour.id}/images/${tour.mainImage})`,
                      }}
                    />
                  </div>
                </div>
              </div>
            )}

            <div
              className="slick-section"
              id="tour-floorPlan"
              ref={(el: any) => {
                this.floorPlans = el;
              }}
            >
              <div className="d-flex justify-content-center">
                <div className="w-50">
                  <div className="d-flex justify-content-start">
                    <h1
                      className={this.state.activeTab === 0 ? 'title active' : 'title'}
                      onClick={() => {
                        this.setState({ activeTab: 0 });
                      }}
                    >
                      {tour.translation?.threeDTour}
                    </h1>
                    {floorPlansOn && (
                      <h1
                        className={this.state.activeTab === 1 ? 'title ml-3 active' : 'title ml-3'}
                        onClick={() => {
                          this.setState({ activeTab: 1 });
                        }}
                      >
                        {tour.translation?.floorPlans}
                      </h1>
                    )}
                  </div>

                  {this.state.activeTab === 0 && (
                    <div className="inner-tab tab-1">
                      <div className="section tour">
                        <div className="inner">
                          {!this.state.play && (
                            <div className="overlay">
                              <div className="text">
                                <img
                                  alt=""
                                  src="/images/play.svg"
                                  onClick={() => {
                                    this.setState({ play: true });
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {!this.state.play && (
                            <div
                              className="bg"
                              style={{
                                backgroundImage: `url(${this.props.reactAws}/tours/${tour.id}/images/${tour.mainImage})`,
                              }}
                            />
                          )}
                          {this.state.play && (
                            <Iframe logoSrc={whitelabel?.logo} src={`/${iframeSrcPrefixByTourType}/${tour.slug}?messenger=0`} allowFullscreen />
                          )}
                        </div>
                      </div>
                      <div className="clearfix" />
                    </div>
                  )}
                  {this.state.activeTab === 1 && (
                    <div className="inner-tab tab-1">
                      {floorPlansOn && <FloorPlan tour={tour} selectedPlan={this.state.selectedPlan} switchPlan={this.switchPlan.bind(this)} imgLong className="h-100" />}
                      <div className="clearfix" />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div
              id="contact"
              className="slick-section"
              ref={(el: any) => {
                this.contact = el;
              }}
            >
              <div className="d-flex justify-content-center">
                <div className="w-50">
                  <h1 className="title">{tour.translation?.contact}</h1>
                  <div className="d-flex">
                    <div className="col-4 p-0 agents">
                      <p className="tab-title mb-5">Presented by</p>
                      {tour.agents.length === 0 && tour.client && (
                        <div className="selected">
                          <div className="d-flex align-items-center agent-wrapper">
                            <div
                              className="agent-profile mr-3"
                              style={{
                                backgroundImage: `url(${this.props.reactAws}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)})`,
                              }}
                            />

                            <div className="agent-info d-flex flex-column align-items-start">
                              <p className="name">{tour.client.name}</p>
                              {tour.client?.website && (
                                <p>
                                  <a href={tour.client?.website?.includes('https://') ? tour.client.website : `https://${tour.client?.website}`} rel="noreferrer" target="_blank">
                                    WEBSITE
                                  </a>
                                </p>
                              )}
                              {tour.client.phone && <p>{tour.client.phone}</p>}
                              {tour.client.email && <p>{tour.client.email}</p>}
                            </div>
                          </div>
                        </div>
                      )}
                      {tour.agents.map((agent: any, i: number) => (
                        <div key={i} className={this.state.selectedAgent === i ? 'selected' : ''}>
                          <div
                            className="d-flex align-items-center agent-wrapper"
                            onClick={() => {
                              this.setState({ selectedAgent: i });
                            }}
                          >
                            <div
                              className="agent-profile mr-3"
                              style={{
                                backgroundImage: `url(${agent.logo})`,
                              }}
                            />

                            <div className="agent-info d-flex flex-column align-items-start">
                              <p className="name">{agent.name}</p>
                              {agent.phone && <p>{agent.phone}</p>}
                              {agent.email && <p>{agent.email}</p>}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {tour.contactForm && (
                      <div className="col-8 p-0 ml-5 contact-form">
                        <p className="tab-title mb-5">{tour.translation?.getInTouch}</p>
                        <form>
                          <div className="d-flex justify-content-between">
                            <input
                              type="text"
                              className="name"
                              placeholder={tour.translation?.name}
                              name="firstName"
                              value={this.state.newLead.firstName ? this.state.newLead.firstName : ''}
                              onChange={this.editLead.bind(this)}
                            />
                            <div />
                            <input
                              type="text"
                              className="name"
                              placeholder={tour.translation?.name}
                              name="lastName"
                              value={this.state.newLead.lastName ? this.state.newLead.lastName : ''}
                              onChange={this.editLead.bind(this)}
                            />
                          </div>
                          <input
                            type="text"
                            placeholder={tour.translation?.email}
                            name="email"
                            value={this.state.newLead.email ? this.state.newLead.email : ''}
                            onChange={this.editLead.bind(this)}
                          />
                          <input
                            type="text"
                            placeholder={tour.translation?.phone}
                            name="phone"
                            value={this.state.newLead.phone ? this.state.newLead.phone : ''}
                            onChange={this.editLead.bind(this)}
                          />
                          <input
                            type="text"
                            placeholder={tour.translation?.message}
                            name="message"
                            value={this.state.newLead.message ? this.state.newLead.message : ''}
                            onChange={this.editLead.bind(this)}
                          />
                          <div className="secondary-btn submit mt-4" onClick={this.sendLead.bind(this)}>
                            {tour.translation?.submit}
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {tour.address && (
            <div className="overview h-400">
              <div className="container m-0 w-100 h-100">
                <div
                  className="row h-100"
                  ref={(el: any) => {
                    this.map = el;
                  }}
                >
                  <Map logo={whitelabel?.logo} address={tour.address} googleKey={this.props.googleKey} />
                </div>
              </div>
            </div>
          )}
          <footer className="d-flex justify-content-center">
            <div className="w-50 d-flex justify-content-between">
              <a href={whitelabel?.website} rel="noreferrer" target="_blank">
                <img className="slick-logo" src={whitelabel?.logo} alt="" />
              </a>
              <div />
              <div>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={`https://www.facebook.com/dialog/share?app_id=${fbAppId || '741048509750318'}&display=popup&href=${encodeURIComponent(
                    window.location.href,
                  )}&redirect_uri=${encodeURIComponent(window.location.href)}`}
                >
                  <i className="fab fa-facebook" />
                </a>
                <a rel="noreferrer" target="_blank" href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(window.location.href)}`}>
                  <i className="fab fa-twitter" />
                </a>
                <a rel="noreferrer" target="_blank" href={`https://wa.me/?text=${encodeURIComponent(window.location.href)}`}>
                  <i className="fab fa-whatsapp" />
                </a>
                <a rel="noreferrer" target="_blank" href={`mailto:?body=${encodeURIComponent(window.location.href)}`}>
                  <i className="fas fa-envelope" />
                </a>
              </div>
            </div>
          </footer>
        </div>
        {tour && !tour.hideCookie && (
          <CustomCookieConsent
            tour={tour}
            loaded={false}
            message={tour.translation?.cookieConsentText}
            accept={tour.translation?.cookieConsentAccept}
            decline={tour.translation?.cookieConsentDecline}
            messageMandatoryTitle={tour.translation?.cookieConsentTextMandatoryTitle}
            messageMandatoryDescription={tour.translation?.cookieConsentTextMandatoryDescription}
            acceptMandatory={tour.translation?.cookieConsentAcceptMandatory}
            declineMandatory={tour.translation?.cookieConsentDeclineMandatory}
          />
        )}
      </div>
    );
  }
}
